import axios from 'axios';

// axios.defaults.timeout = 5000; // 设置请求超时时间
console.log('process.env.NODE_ENV', process.env.NODE_ENV)
const api = axios.create({
    baseURL: process.env.NODE_ENV === "development" ? "/api" : "http://120.31.134.56:7878", // 设置你的API基础URL
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
});
// 设置请求拦截器，在每个请求发送前添加 Authorization 头部
api.interceptors.request.use(config => {
    const token = localStorage.getItem('token'); // 从本地存储中获取 token
    if (token) {
        config.headers.x_access_token = token;
    }
    return config;
}, error => {
    console.log(error);
    return Promise.reject(error);
});
export default {
    //登录
    login(data) {
        return api.post('/sys/login', data).then(res => {
            // 获取请求头信息
            let headers = res.headers;
            console.log('222222222', headers)
            // console.log(headers);
            localStorage.setItem('token', headers.x_access_token)
            return res.data

        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //登出
    logout() {
        return api.post('/sys/logout').then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //会员信息列表
    infoList(data) {
        return api.post('/member/infoList', data).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //助花联盟商品
    GoodsList(data) {
        return api.post('/commodity/zhuHAllianceGoodsList', data).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //待审核商品
    HExamineGoodsList(data) {
        return api.post('/commodity/zhuHExamineGoodsList', data).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //积分商品
    HIntegralGoodsList(data) {
        return api.post('/commodity/zhuHIntegralGoodsList', data).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //会员信息
    memberInfo(data, identity) {
        return api.get('/member/memberInfo', {
            params: {
                userId: data,
                userType: identity
            }
        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //活动商品
    zhuHSeckillGoodsList(data) {
        return api.post('/commodity/zhuHSeckillGoodsList', data).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //商品导出
    productExport(data) {
        return api.post('/commodity/productExport', data, {
            responseType: 'blob'
        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //商品上下架
    productIsSign(data) {
        return api.post('/commodity/productIsSign', data).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //商品审核
    productIsProcess(data) {
        return api.post('/commodity/productIsProcess', data).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //字段筛选（导出）
    exportFieldScreen(data) {
        return api.get('/common/exportFieldScreen/' + data).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //会员导出
    memberExport(data) {
        return api.post('/member/memberExport', data, {
            responseType: 'blob'
        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //助花充值
    zhuRecharge(data) {
        return api.post('/member/zhuRecharge', data).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //推荐人列表
    referenceList(data) {
        return api.get('/member/referenceList', {
            params: {
                userId: data
            }
        }, {
            responseType: 'blob'
        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //修改推荐人
    updateReference(data) {
        return api.put('/member/updateReference', data, {
            responseType: 'blob'
        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //会员封禁
    prohibitUser(data) {
        return api.post('/member/prohibitUser', data, {

        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //余额冻结
    freezeShaw(data) {
        return api.post('/member/freezeShaw', data, {

        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //账号提权
    authority(data) {

        return api.post('/member/authority', data, {

        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //预保存商品信息
    goodsTemporarilySave(data, operationAim) {
        return api.post('/commodity/goodsTemporarilySave', data,
            {
                params: operationAim,
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(res => {
                return res.data
            }).catch(error => {
                // 处理请求错误
                console.error(error);
                throw error;
            });

    },
    //预保存商品图-视频上传
    productFileUpload(scopeType, data) {
        return api.post('/commodity/productFileUpload', data,
            {
                params: { scopeType },
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(res => {
                return res.data
            }).catch(error => {
                // 处理请求错误
                console.error(error);
                throw error;
            });

    },
    //商品分类列表
    productCategory(productType) {
        return api.get('/commodity/productCategory',
            {
                params: {
                    productType
                }
            }).then(res => {
                return res.data
            }).catch(error => {
                // 处理请求错误
                console.error(error);
                throw error;
            });
    },
    //运费模板列表
    freightTemplates(data) {
        return api.get('/freightTemplate/freightTemplate', {
            params: data
        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //运费地区列表
    areaList() {
        return api.get('/freightTemplate/areaList').then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //运费模板添加
    freightTemplate(data) {
        return api.post('/freightTemplate/freightTemplate', data,
            {

                headers: {
                    "Content-Type": "application/json"
                }
            }).then(res => {
                return res.data
            }).catch(error => {
                // 处理请求错误
                console.error(error);
                throw error;
            });
    },
    //运费模板删除-启用
    freightTemplatedel(data) {
        return api.delete('/freightTemplate/freightTemplate',
            {
                params: data

            }).then(res => {
                return res.data
            }).catch(error => {
                // 处理请求错误
                console.error(error);
                throw error;
            });
    },
    //商品详情
    productInfo(data) {
        return api.post('/commodity/productInfo', data).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //商品品牌列表
    storeBrand(storeId) {
        return api.get('/commodity/storeBrand', {
            params: {
                storeId: storeId || 77,
                pageSize:99999
            }
        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    productGoodsType(storeId) {
        return api.get('/commodity/productGoodsType', {
            params: {
                storeId: storeId || 77
            }
        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //商品文件上传
    productFileUpload(data) {
        return api.post('/commodity/productFileUpload', data).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //商品发布
    productRelease(data) {
        return api.post('/commodity/productRelease', data,
            {

                headers: {
                    "Content-Type": "application/json"
                }
            }).then(res => {
                return res.data
            }).catch(error => {
                // 处理请求错误
                console.error(error);
                throw error;
            });
    },
    //商品规格-属性-参数列表

    productSpec(data) {
        return api.get('/productSpec/productSpec', {
            params: data
        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //商品发布
    productRelease(data) {
        return api.post('/commodity/productRelease', data,
            {

                headers: {
                    "Content-Type": "application/json"
                }
            }).then(res => {
                return res.data
            }).catch(error => {
                // 处理请求错误
                console.error(error);
                throw error;
            });
    },
    //运费模板信息
    freightTemplateInfo(data) {
        return api.get('/freightTemplate/freightTemplateInfo', {
            params: {
                templateId: data
            }
        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //运费模板编辑
    freightTemplateput(data) {
        return api.put('/freightTemplate/freightTemplate', data,
            {

                headers: {
                    "Content-Type": "application/json"
                }
            }).then(res => {
                return res.data
            }).catch(error => {
                // 处理请求错误
                console.error(error);
                throw error;
            });
    },
    //规格类型列表
    specTypeList(data) {
        return api.get('/productSpec/specTypeList', {
            params: data
        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //规格-参数列表
    productSpec(data) {
        return api.get('/productSpec/spec', {
            params: data
        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });

    },
    spec(data) {
        return api.delete('/productSpec/spec', {
            params: data
        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    specPUT(data) {
        return api.put('/productSpec/spec', data,
            {

                headers: {
                    "Content-Type": "application/json"
                }
            }).then(res => {
                return res.data
            }).catch(error => {
                // 处理请求错误
                console.error(error);
                throw error;
            });
    },
    specadd(data) {
        return api.post('/productSpec/spec', data,
            {

                headers: {
                    "Content-Type": "application/json"
                }
            }).then(res => {
                return res.data
            }).catch(error => {
                // 处理请求错误
                console.error(error);
                throw error;
            });
    },
    specTypedel(goodsTypeId) {
        return api.delete('/productSpec/specType', {
            params: {
                goodsTypeId,
            }
        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    // specTypeput(data) {
    //     return api.put('/productSpec/specType', data
    //     ).then(res => {
    //         return res.data
    //     }).catch(error => {
    //         // 处理请求错误
    //         console.error(error);
    //         throw error;
    //     });
    // },
    //商品佣金设置
    kickback(data) {
        return api.post('/commodity/kickback', data, {
            headers: {
                'Content-Type': 'application/json'
            },
        }
        ).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //分销码
    distributionCode(data){
        return api.post('/distributionCode/distributionCode', data).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //品牌列表
    brandList(data){
        return api.get('/goods/brand/brandList', {
            params: data
        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //品牌删除
    dbrand(data){
        return api.delete('/goods/brand/brand', {
            params: data
        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //品牌添加-编辑
    pbrand(data){
        return api.post('/goods/brand/brand', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    },
    //测试
    test() {
        return api.post('/zhuh/ecmsTest/token', null, {
            responseType: 'blob'
        }).then(res => {
            return res.data
        }).catch(error => {
            // 处理请求错误
            console.error(error);
            throw error;
        });
    }
}